import type { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  apiBase: 'https://api.innovation.prg-dev.com/api',
  fileBase: 'files',
  maxCacheSize: 50,
  auth: {
    issuer: 'https://id.innovation.prg-dev.com',
    clientId: '1a1eb8eb4e2d8e88d938',
    showDebugInformation: true,
  },
  uploader: {
    dashboardHeight: 250,
    maxFileSize: 20 * 1024 * 1024,
    maxNumberOfFiles: 10,
  },
};
